import { types } from '../../types/types'
import AfiliadoService from '../../services/AfiliadoService'
import { startAlerta } from '../ui/alertas'
import { finishSpinner, startSpinner } from '../ui/spinner'
import { fetchGrupoFamiliar } from '../grupoFamiliar'


export const enviarSinFicha = (id_motivo_SF, sinFicha, handleClosePopSinFicha) => 
  async (dispatch, getState) => {
    try {
        dispatch(startSpinner())
        const { afiliado } = getState().afiliacion;

        let result= await AfiliadoService.ingresarSinFicha({idAfiliado:afiliado.id_afiliado, id_motivo_SF:id_motivo_SF,sinFicha:sinFicha})
          const body = await result.json()
          if (result.ok) {
            handleClosePopSinFicha && handleClosePopSinFicha();
            dispatch({
              type: types.afiliacionesActualizarSinFicha,
              payload: body
          })
            dispatch(fetchGrupoFamiliar(afiliado.id_afiliado));
            dispatch(finishSpinner())
            dispatch(startAlerta(`Sin Ficha Actualizado`,'success','Comando Exitoso'))
          } else {
            throw body.errores
          }
       // alert(afiliado.id_afiliado);
        //alert(observacion);
        dispatch(finishSpinner());
    } catch (error) {
        dispatch(finishSpinner())
        if (error && error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}